export class AccountInvitation {
    isV2?: boolean;
    inviteeEmail!: string;
}